import { socials } from "../../../../links"
import { Link } from "react-router-dom"
import logo from '../../../../assets/images/2.webp'
import { FaTelegram } from "react-icons/fa6";
import { FaDiscord } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaMedium } from "react-icons/fa";
import { WalletModalProvider, WalletDisconnectButton, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useConnection, useWallet } from "@solana/wallet-adapter-react";

import React, { useEffect, useState } from "react";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import ConnectWallet from "../../../../components/ConnectWallet/ConnectWallet";
import SocialMediaLinks from "../../../../components/SocialMediaLinks/SocialMediaLinks";



export default function DashboardHeader() {

 

    return (

        <div className='w-full h-full  shadow-xl space-y-2  rounded-lg border-neutral-500/20 border    bg-yellow-500/10 backdrop-blur p-5'>
            <div className='flex justify-between items-center'>
                <div className='flex gap-2 items-center'>
                    <img src={logo} alt="" className='rounded-full max-h-10 max-w-10 md:w-20 md:h-20 ' />

                    <div className='flex flex-col gap-1 '>
                        <h1 className='font-bold text-md  text-orange-500'>PHOENIX ($PX)</h1>
                        <p className='text-neutral-300 text-xs'>Supply :  1 Billion</p>
                        <p className='text-neutral-300 text-xs'>Decimals : 6</p>

                       

                    </div>
                </div>

                <div className='flex flex-col gap-2 items-center '>
                    <ConnectWallet />
                </div>

            </div>
                    <SocialMediaLinks />
        </div>

    )
}




